import { PropTypes } from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Icon, Menu, Responsive } from "semantic-ui-react";
import styled from "styled-components";
import SidasApiLogo from "../sidas-api-logo";
import OrganizationAutosuggest from "./../organization-autosuggest";
import { toggleSidebar } from "./../../redux/modules/navigationSidebar";

const Header = ({ isAuthenticated, onToggleSidebar }) => (
  <header>
    <Menu attached borderless>
      {isAuthenticated && (
        <Responsive as={Menu.Item} maxWidth={Responsive.onlyTablet.maxWidth}>
          <Button
            aria-label="Menu"
            basic
            icon="bars"
            onClick={onToggleSidebar}
          />
        </Responsive>
      )}
      <Menu.Item>
        <ImageLink to="/">
          <SidasApiLogo />
        </ImageLink>
      </Menu.Item>

      <Menu.Menu position="right">
        <Responsive minWidth={Responsive.onlyTablet.minWidth}>
          <Menu.Item>
            <OrganizationAutosuggest />
          </Menu.Item>
        </Responsive>
        <Menu.Item>
          <Responsive as={Fragment} maxWidth={Responsive.onlyMobile.maxWidth}>
            <Button
              aria-label="Specyfikacja API"
              as={Link}
              color="orange"
              icon
              title="Specyfikacja API"
              to="/widget"
            >
              <Icon name="info circle" />
            </Button>
          </Responsive>

          <Responsive as={Fragment} minWidth={Responsive.onlyTablet.minWidth}>
            <Button
              as={Link}
              color="orange"
              icon
              labelPosition="left"
              to="/widget"
            >
              <Icon name="info circle" /> Specyfikacja API
            </Button>
          </Responsive>
        </Menu.Item>
      </Menu.Menu>
    </Menu>
  </header>
);

Header.propTypes = {
  isAuthenticated: PropTypes.bool,
  onToggleSidebar: PropTypes.func.isRequired
};

const ImageLink = styled(Link)`
  display: flex;
`;

const mapStateToProps = ({ authentication: { accessToken } }) => ({
  isAuthenticated: accessToken !== null
});

const mapDispatchToProps = dispatch => ({
  onToggleSidebar: () => dispatch(toggleSidebar())
});

const enhance = connect(
  mapStateToProps,
  mapDispatchToProps
);

export { Header };
export default enhance(Header);



// WEBPACK FOOTER //
// ./src/components/header/Header.js